import { utils } from '@hh/global.js'

const { debounce } = utils

class HHFiltersWrapper extends HTMLElement {
  constructor() {
    super()
    this.filterData = []
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this)
    this.closeDetails = this.closeDetails.bind(this)
    this.onHistoryChange = this.onHistoryChange.bind(this)
    this.closeMobileFilters = this.closeMobileFilters.bind(this)
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event)
    }, 500).bind(this)
  }

  connectedCallback() {
    const submitInputs = this.querySelectorAll('.js-filter-submit')
    const sortInput = this.querySelector('.js-sort-input')
    const closeButton = this.querySelector('.js-close')

    this.bindActiveFacetButtonEvents()
    window.addEventListener('popstate', this.onHistoryChange)
    document.body.addEventListener('click', this.closeDetails)
    submitInputs.forEach((element) => {
      element.addEventListener('click', this.debouncedOnSubmit)
    })
    sortInput && sortInput.addEventListener('change', this.debouncedOnSubmit)

    closeButton?.addEventListener('click', this.closeMobileFilters)
  }

  closeMobileFilters() {
    this.dispatchEvent(
      new CustomEvent('closeModal', {
        bubbles: true,
      })
    )
  }

  closeDetails(event) {
    const sortInput = this.querySelector('.js-sort-input') 
    const trigger = document.querySelector('.filters__trigger.js-drawer-trigger') 

    const detailsElements = this.querySelectorAll('.js-filter')
    detailsElements.forEach((detailsElement) => {
      if (!detailsElement.contains(event.target) && !sortInput.contains(event.target) && !trigger.contains(event.target)) {
        detailsElement.open = false
      }
    })
  }

  onSubmitHandler(event) {
    event.preventDefault()
    const formData = new FormData(event.target.closest('form'))
    const searchParams = new URLSearchParams(formData).toString()
    this.renderPage(searchParams, event)
  }

  onActiveFilterClick(event) {
    event.preventDefault()
    this.toggleActiveFacets()

    this.renderPage(new URL(event.currentTarget.href).searchParams.toString())
  }

  onHistoryChange(event) {
    const searchParams = event.state?.searchParams || ''
    this.renderPage(searchParams, null, false)
  }

  toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable)
    })
  }

  renderPage(searchParams, event, updateURLHash = true) {
    document
      .getElementById('CollectionProductGrid')
      .querySelector('.js-product-grid-list')
      .classList.add('loading')

    const url =
      `${window.location.pathname}?` +
      this.getSections()
        .map((section) => `sections[]=${section.section}`)
        .join('&') +
      `&${searchParams}`

    const filterDataUrl = (element) => element.url === url

    this.filterData.some(filterDataUrl)
      ? this.renderSectionFromCache(filterDataUrl, event)
      : this.renderSectionFromFetch(url, event)

    if (updateURLHash) this.updateURLHash(searchParams)
  }

  renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.json())
      .then((parsed) => {
        const html = Object.values(parsed).join('')
        this.filterData = [...this.filterData, { html, url }]
        this.renderFilters(html, event)
        this.renderProductGrid(html)
      })
  }

  renderSectionFromCache(filterDataUrl, event) {
    const html = this.filterData.find(filterDataUrl).html
    this.renderFilters(html, event)
    this.renderProductGrid(html)
  }

  renderProductGrid(html) {
    const innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('CollectionProductGrid').innerHTML

    document.getElementById('CollectionProductGrid').innerHTML = innerHTML
  }

  renderFilters(...args) {
    this.renderSingleFormFilters(...args)
  }

  renderSingleFormFilters(html) {
    const activeElement = document.activeElement
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html')

    const facetsToRender = parsedHTML.querySelectorAll(
      '#CollectionFiltersFormMobile .js-filter'
    )

    facetsToRender.forEach((element) => {
      document.querySelector(
        `#CollectionFiltersFormMobile .js-filter[data-index="${element.dataset.index}"]`
      ).innerHTML = element.innerHTML
    })

    this.renderActiveFacets(parsedHTML)

    const submitInputs = this.querySelectorAll('.js-filter-submit')
    submitInputs?.forEach((element) => {
      element.addEventListener('click', this.debouncedOnSubmit)
    })
    activeElement.focus()
  }

  renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      '.js-facets--mobile',
      '.js-facets--desktop',
    ]

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector)
      if (!activeFacetsElement) return
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML
    })

    this.bindActiveFacetButtonEvents()
    this.toggleActiveFacets(false)
  }

  bindActiveFacetButtonEvents() {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.addEventListener('click', this.onActiveFilterClick, {
        once: true,
      })
    })
  }

  updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      '',
      `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`
    )
  }

  getSections() {
    return [
      {
        id: 'main-collection-filters',
        section: document.getElementById('main-collection-filters').dataset.id,
      },
      {
        id: 'CollectionProductGrid',
        section: document.getElementById('CollectionProductGrid').dataset
          .id,
      },
    ]
  }
}

customElements.define('hh-filters-wrapper', HHFiltersWrapper)
